import { motion } from "framer-motion";

const items = [
  {
    quote:
      "Called Friday night with a burst pipe. JLP had a crew on-site in under 40 minutes and had the entire kitchen re-plumbed and back to normal by Sunday.",
    name: "Marisa D.",
    role: "Homeowner · Bethlehem, PA",
  },
  {
    quote:
      "We hired JLP for our 18,000 sq ft office fit-out. On time, on budget, and the finish work was frankly better than what we've had from firms three times the size.",
    name: "Andre P.",
    role: "COO · Regional Retail Group",
  },
  {
    quote:
      "They fixed a squeaky door for us in October. Six months later they were building our addition. That says everything.",
    name: "The Colton Family",
    role: "Residential Client · Emmaus, PA",
  },
];

const stats = [
  { n: "600+", label: "Projects Completed" },
  { n: "24/7", label: "Emergency Response" },
  { n: "100%", label: "Licensed · Insured · Bonded" },
  { n: "0", label: "Voicemails. We Answer." },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-black py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="grid gap-6 md:grid-cols-[1fr_1.4fr] md:items-end">
          <div>
            <div className="eyebrow">— Word of Mouth</div>
            <h2 className="mt-6 font-oswald text-5xl uppercase leading-[0.9] tracking-tight text-white md:text-7xl">
              Trusted
              <br />
              <span className="text-white/40">the old way.</span>
            </h2>
          </div>
          <p className="max-w-xl font-editorial text-lg italic text-white/70 md:text-xl">
            No paid reviews, no five-star script. Just neighbours calling
            neighbours.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:mt-20 md:grid-cols-3 md:gap-8">
          {items.map((t, i) => (
            <motion.blockquote
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{
                duration: 0.9,
                ease: [0.2, 0.8, 0.2, 1],
                delay: i * 0.1,
              }}
              className="relative border border-white/10 bg-[#0a0a0a] p-8"
            >
              <span className="absolute -top-6 left-6 font-editorial text-8xl italic leading-none text-[color:var(--accent)]">
                “
              </span>
              <p className="relative font-editorial text-lg italic leading-relaxed text-white/90 md:text-xl">
                {t.quote}
              </p>
              <footer className="mt-6 border-t border-white/10 pt-4">
                <div className="font-oswald text-sm uppercase tracking-[0.2em] text-white">
                  {t.name}
                </div>
                <div className="mt-1 font-mono text-[11px] tracking-widest text-white/50">
                  {t.role}
                </div>
              </footer>
            </motion.blockquote>
          ))}
        </div>

        {/* Stats bar */}
        <div className="mt-20 grid grid-cols-2 border border-white/10 md:mt-28 md:grid-cols-4">
          {stats.map((s, i) => (
            <div
              key={i}
              className="border-b border-r border-white/10 p-6 last:border-r-0 md:border-b-0 md:p-10"
              data-testid={`stat-${i}`}
            >
              <div className="font-oswald text-5xl uppercase leading-none text-white md:text-6xl">
                {s.n}
              </div>
              <div className="mt-3 font-mono text-[11px] uppercase tracking-widest text-white/50">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
